import { Alert, Box } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";

import { spacing } from "@indeed/ifl-tokens/react-native";
import { differenceInCalendarDays } from "date-fns";
import React, { useMemo } from "react";
import { StyleSheet } from "react-native";

const APPLICATION_DRAFT_TTL_MS = 14 * 24 * 60 * 60 * 1000;

export function getApplicationDraftAgeInCalendarDays(
  expiryTime: number,
  now: number = Date.now(),
): number {
  const initialSaveDate = new Date(expiryTime - APPLICATION_DRAFT_TTL_MS);
  return Math.max(0, differenceInCalendarDays(new Date(now), initialSaveDate));
}

export function SavedApplicationBanner(): React.JSX.Element | null {
  const i18n = useI18n();
  const savedJob = useViewjobOneGraphModel()?.job.savedJob;
  const expiryTime = savedJob?.applicationDraft?.expiryTime;
  const now = useMemo(() => Date.now(), []);

  const isVisible = savedJob?.state === "SAVED" && expiryTime != null && expiryTime > now;

  const draftAgeInDays =
    isVisible && expiryTime != null ? getApplicationDraftAgeInCalendarDays(expiryTime, now) : 0;

  const explainerText = useMemo(() => {
    if (draftAgeInDays === 0) {
      return i18n.pgettext(
        "save_and_continue_m2_banner_content",
        "You started this application today",
      );
    }
    return i18n.npgettext(
      "save_and_continue_m2_banner_content",
      "You started this application {0} day ago",
      "You started this application {0} days ago",
      draftAgeInDays,
      draftAgeInDays.toString(),
    );
  }, [draftAgeInDays, i18n]);

  if (!isVisible) {
    return null;
  }

  return (
    <Box sx={styles.container}>
      <Alert
        status="info"
        title={i18n.pgettext("save_and_continue_m2_banner", "Ready to finish your application?")}
        explainerText={explainerText}
      />
    </Box>
  );
}

const styles = StyleSheet.create({
  container: {
    marginHorizontal: spacing.s4,
    marginBottom: spacing.s4,
  },
});
